import { FaqTypes as Type } from '../../../types/faq';

const initialState = {
  addMessage: null,
  loading: false,
  error: null,
};

const AddFaqReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.ADD_FAQ_REQUEST:
      return { ...state, addMessage: null, loading: true, error: null };

    case Type.ADD_FAQ_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        addMessage: action.payload.message
      };
    case Type.ADD_FAQ_REQUEST_FAILURE:
      return { ...state, addMessage: null, error: action.error, loading: false };
    case Type.RESET_ADD_FAQ_STATE:
      return { ...initialState };
    default:
      return state;
  }
};

export default AddFaqReducer;